import React from 'react';
import { Box, Typography, Container } from '@mui/material';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#111111',
        color: 'white',
        py: 3,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="body2"
          align="center"
          sx={{
            fontFamily: 'var(--font-heading)',
            fontWeight: 'var(--weight-medium)',
            fontSize: '0.9rem',
            wordSpacing: '0.2rem',
          }}
        >
          © {currentYear} CEOKeynotes.com. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer; 